import classNames from 'classnames/bind';
import styles from './EditBox.module.css';

import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import useModal from '../../../hooks/useModal';
import { useSlice } from '../../../hooks/useSlice';
import { selectMenu } from '../../../features/infoSlice';
import {
  driveSharedToggled,
  selectDriveOptions,
} from '../../../features/driveSlice';

import { Resource } from '../../../types/drive';

import {
  SELECT_ALL,
  DELETE,
  COMPLETE,
  SHOW_NOT_SHARED_FILE,
} from '../../../constants';
import { isMobile } from '../../../utils/util';
import { isOfType } from '../../../utils/typeGuard';

export default function EditBox() {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const slice = useSlice();
  const menu = useAppSelector(selectMenu);
  const { isShowShared } = useAppSelector(selectDriveOptions);

  const {
    editModeToggled,
    itemSelected,
    selectSelectedIds,
    selectAll,
    selectIds,
  } = slice;
  const selectedIds = useAppSelector(selectSelectedIds);
  const allResources = useAppSelector(selectAll);
  const ids = useAppSelector(selectIds);

  const { toggleModal } = useModal();

  const selectedLen = selectedIds.length;
  const isDrive = menu === 'mydrive';

  const selectAllList = () => {
    const fileIds = isDrive
      ? allResources.reduce(
          (acc: number[], cur) =>
            isOfType(cur, 'resource')
              ? cur.resource.ext !== 'folder' && (isShowShared || !cur.share)
                ? [...acc, cur.resource.resourceId]
                : acc
              : acc,

          []
        )
      : ids;

    selectedLen === fileIds.length
      ? dispatch(itemSelected({ ids: [] }))
      : dispatch(itemSelected({ ids: fileIds }));
  };

  const removeItems = async () => {
    const id = {
      library: 'confirmDeleteFile',
      share: 'confirmDeleteShared',
      mydrive: 'confirmDeleteFile',
      trash: 'confirmDelCompletly',
    }[menu] as string;

    selectedLen &&
      toggleModal({
        id,
        type: 'confirm',
      });
  };

  const completeEdit = () => {
    dispatch(editModeToggled(false));
    dispatch(itemSelected({ ids: [], item: null }));
    isDrive && dispatch(driveSharedToggled(true));
  };

  const toggleSharedFile = () => {
    const fileIds = allResources.reduce(
      (acc: number[], cur) =>
        isOfType(cur, 'resource')
          ? selectedIds.includes(cur.resource.resourceId) &&
            (!isShowShared || !cur.share)
            ? [...acc, cur.resource.resourceId]
            : acc
          : acc,
      []
    );
    dispatch(driveSharedToggled(!isShowShared));
    dispatch(itemSelected({ ids: fileIds }));
  };

  return (
    <span className={cx('edit_active_box')}>
      {isDrive && (
        <span className={cx('view_share')}>
          <label>
            <input
              type="checkbox"
              id="show_no_shared"
              className={cx('blind')}
              onChange={toggleSharedFile}
            />
            <span className={cx('clabel')}>{SHOW_NOT_SHARED_FILE}</span>
          </label>
        </span>
      )}
      {!isMobile && (
        <span
          role="button"
          className={cx('btn', 'b_t', 's30', 'dull')}
          onClick={selectAllList}
        >
          <span>{SELECT_ALL}</span>
        </span>
      )}
      <span
        role="button"
        className={cx('btn', 'b_t', 's30', 'point', {
          'is--disabled': !selectedLen,
        })}
        onClick={removeItems}
      >
        <span>{DELETE}</span>
      </span>
      <span
        role="button"
        className={cx('btn', 'b_t', 's30', 'dull')}
        onClick={completeEdit}
      >
        <span>{COMPLETE}</span>
      </span>
    </span>
  );
}
